export default {"src":"/_next/static/media/surfaces.c71bcbf1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};